import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  ReadTrackingBannerSource,
  ReadTrackingService
} from 'src/app/services/read-tracking.service';
import { Question } from 'src/app/services/question.service';
import { SearchResult } from 'src/app/services/search.service';
import { environment } from 'src/environments/environment';
// import { fromEvent } from 'rxjs';
// import { distinctUntilChanged, filter, map } from 'rxjs/operators';
@Component({
  selector: 'mvp-questions-list',
  templateUrl: './questions-list.component.html',
})
export class QuestionsListComponent implements OnInit {

  @ViewChild('list', { static: true }) list: ElementRef;

  @Input() questions: Array<Question | SearchResult>;
  @Input() toFullList: string;
  @Input() title: string;
  @Input() trackingSource: 'homepage' | ReadTrackingBannerSource = 'homepage';
  // @Output() loadMore = new EventEmitter();
  assetUrl: string = environment.assetUrl;
  activeCardIndex: number = 0;
  environment = environment;

  constructor(
    private router: Router,
    private readTrackingService: ReadTrackingService,
  ) { }

  ngOnInit() {
    this.updateActiveChip();
  }

  async goToQuestion(question: Question | SearchResult) {
    const queryParamsBase = {
      fromList: 'true',
    };

    const queryParams = this.trackingSource === 'homepage'
      ? this.readTrackingService.withHomepageSource(queryParamsBase)
      : this.readTrackingService.withBannerSource(this.trackingSource, queryParamsBase);

    if (this.trackingSource !== 'homepage') {
      const trackingListUuids = this.serializeTrackingListUuids(this.questions);
      if (trackingListUuids) {
        queryParams.tracking_list_uuids = trackingListUuids;
      }
    }

    this.router.navigate([`question/${question.uuid}`], {
      queryParams,
    });
  }

  private serializeTrackingListUuids(items: Array<Question | SearchResult>): string | undefined {
    const seen = new Set<string>();
    const orderedUuids = (items || [])
      .map(item => String(item?.uuid || '').trim())
      .filter(uuid => uuid !== '')
      .filter((uuid) => {
        if (seen.has(uuid)) {
          return false;
        }

        seen.add(uuid);
        return true;
      });

    if (orderedUuids.length < 2) {
      return undefined;
    }

    return orderedUuids.join(',');
  }


  scrollList(direction: 'left' | 'right') {
    const amount = 300;
    this.list.nativeElement.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateActiveChip();
  }

  onScroll() {
    this.updateActiveChip();
  }

  updateActiveChip() {
    const listElement = this.list.nativeElement;
    const scrollLeft = listElement.scrollLeft;
    const viewportWidth = listElement.offsetWidth;

    let maxVisibleWidth = 0;
    let newActiveCardIndex = 0;

    const children = listElement.children;

    for (let i = 0; i < children.length; i++) {
      const card = children[i];
      const cardStart = card.offsetLeft - scrollLeft;
      const cardEnd = cardStart + card.offsetWidth;

      const visibleWidth =
        Math.min(cardEnd, viewportWidth) - Math.max(cardStart, 0);

      if (visibleWidth > maxVisibleWidth) {
        maxVisibleWidth = visibleWidth;
        newActiveCardIndex = i;
      }
    }

    this.activeCardIndex = newActiveCardIndex;
  }

  activeChipColor() {
    if (environment.application === 'tract') {
      return ' bg-[#FFA500]'
    }
    return ' bg-yellow-400'
  }

    inactiveChipColor() {
    if (environment.application === 'tract') {
      return ' bg-gray-200'
    }   
    return ' bg-white';
  }
}
